import { RadioGroup } from '@headlessui/react'
import { Fragment, useState } from 'react'

type ButtonTypes = {
  options?: Array<{
    key?: string
    value: any
    text: string
    field?: string
    name?: string
    textarea?: string
    description?: string
    renderOnChecked?: any
    label?: any
  }>
  onChange?: (value: any) => void
  defaultValue?: string
  // Optional controlled value. When provided, the parent owns the selection
  // (the group reflects `value` exactly) so it can veto a change — e.g. holding
  // a radio off until a confirmation dialog is accepted. When omitted, the
  // component stays internally stateful as before (backward-compatible).
  value?: string
  disabled?: boolean
}

export default function RadioInput({
  options,
  onChange,
  defaultValue,
  value,
  disabled,
}: ButtonTypes) {
  const [selectedValue, setSelectedValue] = useState(defaultValue)
  const isControlled = value !== undefined
  const currentValue = isControlled ? value : selectedValue
  return (
    <RadioGroup
      value={currentValue}
      onChange={(next) => {
        if (!isControlled) setSelectedValue(next)
        onChange && onChange(next)
      }}
      disabled={disabled}
    >
      {options?.map((option: any, index: number) => (
        <Fragment key={option?.key ?? option?.value ?? index}>
          <RadioGroup.Option
            value={option?.value}
            // className={`flex flex-wrap items-center gap-x-1 pb-5 before:bg-amber-700 before:w-4 before:h-4 before:rounded-full`}
            className={({ active, checked }) =>
              `flex flex-wrap items-center pb-2 md:pb-5 ${
                checked
                  ? 'before:bg-checkbox-rounded before:bg-contain'
                  : 'before:bg-white before:border before:border-gray-300'
              } before:w-4 before:h-4 before:rounded-full`
            }
          >
            <RadioGroup.Label className="pl-1">{option?.text}</RadioGroup.Label>
            {option.description ? (
              <RadioGroup.Description className="basis-full text-xs block pl-5">
                {option.description}
              </RadioGroup.Description>
            ) : (
              ''
            )}
          </RadioGroup.Option>
          {option.renderOnChecked && currentValue === option?.value && (
            <>{option.renderOnChecked}</>
          )}
        </Fragment>
      ))}
    </RadioGroup>
  )
}
